import type { tProfileColorTheme } from 'common/modules/ReactShared';

export type tTheme = 'dark' | 'light';
/** What the student picked: `system` follows the device's light/dark setting. */
export type tThemePreference = tProfileColorTheme;
/** The palette when the device cannot tell: the only theme before light existed. */
export const DEFAULT_THEME: tTheme = 'dark';
export const DEFAULT_THEME_PREFERENCE: tThemePreference = 'system';
